import moment from "moment";

export default (start: string) => {
  const startDate = moment(`02-02-2017 00:00`, "DD-MM-YYYY HH:mm");
  const endDate = moment(`02-02-2017 ${start}`, "DD-MM-YYYY HH:mm");
  const duration = moment.duration(endDate.diff(startDate));
  return duration.asHours();
};
